import React from 'react'
import {IconButton as MuiIconButton, Tooltip} from '@mui/material'

function IconButton({tooltip, ...props}) {
  if (tooltip) {
    return (
      <Tooltip title={tooltip}>
        {/* 加 span 是為了不讓 Tooltip 因為 disabled button 而跳警告 */}
        <span>
          <MuiIconButton  {...props}/>
        </span>
      </Tooltip>
    )
  }

  return (
    <MuiIconButton {...props}/>
  )
}

export default React.memo(IconButton)